var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"nav-link",class:_vm.active === true ? 'active' : '',attrs:{"href":"javascript:"},on:{"click":function($event){return _vm.onClick()}}},[_vm._v(" "+_vm._s(_vm.tag.name)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }